import React, { useCallback, useEffect, useState } from 'react'

const InputRadio = ({ id = Date.now().toString(), value, checked:checkedValue, label, className, onChange, ...props  }) => {
    const [checked, setChecked] = useState(false);

    const handleChange = useCallback((event) => {
        setChecked(event.target.checked);
        onChange && onChange(event.target.checked, event)
    }, [onChange]);

    useEffect(() => {
        if(typeof checkedValue === 'boolean'){
            setChecked(checkedValue);
        }
    }, [checkedValue])

    return (
        <div className={`bimmatch-input-radio ${className || ""}`}>
            <input
                type="radio"
                value={value}
                id={id}
                checked={checked}
                onChange={handleChange}
                className='input-radio'
                {...props}
            />
            {label && (
                <label htmlFor={id} className="radio-label"> {label} </label>
            )}
        </div>
    )
}

export default InputRadio